export const sharedFileDefaultValues = {
  instructions: "",
  mimeTypes: {}
} as const;
